import React, { useState } from 'react';
import { TicketCheck } from 'lucide-react';
import { useDisclosure } from '@mantine/hooks';

import { EButton, EModal } from 'libs/ui';
import { showToast } from 'utils/utility';
import { useHotelData } from 'libs/data-access';
import { IHotelOnlineBookingList, TBookingStatus } from 'libs/data-access/types';

interface IProps {
    hotelTicket: IHotelOnlineBookingList;
    handleRefresh: () => void;
};

export default function GenerateVoucher({ hotelTicket, handleRefresh }: IProps) {

    const {
        postHotelData
    } = useHotelData();


    const STATUS: TBookingStatus = "SUCCESS";

    const [confirmModal, { open: openConfirmModal, close: closeConfirmModal }] = useDisclosure(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    // API CALLS
    const generateVoucher = async () => {
        setIsLoading(true);

        const response = await postHotelData(`/booking/${hotelTicket.id}/change-booking-status?bookingStatus=${STATUS}`, null);

        setIsLoading(false);

        if (response.isSuccess) {
            // console.log("Response for hotel vouchering: ", response.data);
            handleRefresh();
        } else {
            console.log("Error while generating voucher: ", response);
            showToast({
                type: "error",
                message: response.message
            });
        };
    };


    return (
        <>
            <EButton
                size="sm"
                variant="light"
                leftSection={<TicketCheck />}
                onClick={openConfirmModal}
            >Generate Voucher</EButton>

            {/* VOUCHER CONFIRMATION MODAL */}
            <EModal
                opened={confirmModal}
                onClose={closeConfirmModal}
            >
                <div className="flex flex-col gap-6">
                    <span className="font-semibold text-lg">Are you sure you want to generate voucher for this booking?</span>

                    <div className="flex justify-end gap-2">
                        <EButton
                            autoContrast
                            size="sm"
                            disabled={confirmModal}
                            onClick={closeConfirmModal}
                        >No</EButton>
                        <EButton
                            size="sm"
                            color="red"
                            variant="light"
                            loading={isLoading}
                            onClick={generateVoucher}
                        >Yes</EButton>
                    </div>
                </div>
            </EModal>
        </>
    );

}